import React from 'react';
import styles from './Feature.module.scss';

const Feature = (props: any) => {
  return (
    <div className={styles['feature-wrapper']}>
      <div>
        {/* <img src="features-icon.webp" alt='icon' style={{width:48, height:48}} /> */}
      </div>
      <div >
        <p className={styles['heading']}>{props.heading}</p>
        <p className={styles['sub-heading']}>{props.subHeading}</p>

      </div>
      <div>
        <ul className={styles['ul-list']}>
          {props.data &&
            props.data.map((item:string,index:any)=>   
            <li key={`feature-${index}`} className={styles['list-item']}>
            <img src="features-icon2.webp" alt='icon1' style={{width:23.33, height:23.33, marginTop:10}}/>
            <p className={styles['list-item-text']}>{item}</p>
          </li>)
          }
       
         
          
        </ul>
      </div>
    </div>
  );
};

export default Feature;
